module.exports = __webpack_public_path__ + "img/addIcon.883b4754.svg";